module.exports = __webpack_public_path__ + "9d28b6ea3bdd48077052ae76e6900db4.png";